module.exports = __webpack_public_path__ + "img/shine-bg.00e5b61b.png";